import BaseComponent from '../base-component/base-component'
import { debounce } from '../../utils/debounce'
import { Nullable } from '../../types/common'

class MaxLinesComponent extends BaseComponent {
  resizeObserver: ResizeObserver
  lineClamp: Nullable<HTMLElement>
  target: Nullable<HTMLElement>
  styles: CSSStyleDeclaration

  constructor() {
    super()

    this.resizeObserver = new ResizeObserver(this.handleResize)
    this.resizeObserver.observe(this)

    this.lineClamp = this.querySelector('[data-quote-line-clamp]')
    this.target = this.querySelector('[data-quote-line-clamp-target]')

    this.styles = getComputedStyle(this.target)
  }

  disconnectedCallback(): void {
    this.resizeObserver.disconnect()
  }

  handleResize = debounce((): void => {
    this.update()
  }, 100)

  update(): void {
    const maxLines = this.getMaxLines()

    if (maxLines) {
      this.setMaxLines(maxLines)
    }
  }

  setMaxLines(maxLines: number): void {
    if (!this.target) {
      return
    }

    this.target.style.setProperty('--gsc-max-lines', `${maxLines}`)

    this.setAttribute('data-line-clamp-setter-is-ready', '')
  }

  getMaxLines(): number {
    if (!this.lineClamp || !this.target) {
      return 0
    }

    const lineHeight = this.styles['lineHeight']
    const height = this.lineClamp.offsetHeight
    const maxLines = Math.floor(height / parseFloat(lineHeight))

    return maxLines
  }
}

export default MaxLinesComponent
